import PlatformStateHistoryGatewayInterface from '../../domain/PlatformStateHistory/PlatformStateHistoryGatewayInterface'
import { PlatformStateHistoryInterface } from '../../domain/PlatformStateHistory/PlatformStateHistory'
import Caller from '../../domain/Api/Caller'
import envVariable from '../../presentation/util/envVariable'

export default class PlatformStateHistoryGateway implements PlatformStateHistoryGatewayInterface {
  async retrieveList(dossierId: string): Promise<PlatformStateHistoryInterface[] | null> {
    try {
      return await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossier/platform-state/${dossierId}/history`, {})
    } catch {
      return null
    }
  }
}
